exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2u9qF{position:relative;background:#fff;padding:15px;margin-bottom:20px}._1MnP2{font-size:13px;font-weight:400;margin:10px 0}._1Kp1S{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:10px 0}._1Kp1S:not(:first-of-type):last-of-type{margin:0}._2BNfs{margin:0 10px 10px 0;font-size:12px;padding:6px 12px;border:1px solid #ccc;border-radius:2px;cursor:pointer;background:transparent;outline:0;text-transform:capitalize;color:inherit;text-decoration:none;max-width:calc(100% - 34px);overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;-webkit-box-sizing:content-box;box-sizing:content-box}._2BNfs:focus,._2BNfs:hover,.U0pd4{color:#e73232}._1M3kG{display:inline-block;margin-top:10px;font-size:14px}", ""]);

// exports
exports.locals = {
	"root": "_2u9qF",
	"title": "_1MnP2",
	"list": "_1Kp1S",
	"tag": "_2BNfs",
	"active": "U0pd4",
	"clearFilters": "_1M3kG"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/TagList/TagList.css
// module id = 2792
// module chunks = 16 21